import styled from 'styled-components';

export const Wrapper = styled.div`
  background: rgb(255 255 255 / 38%);
  border-radius: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 130px;
  svg {
    width: 70px;
    height: 70px;
  }
  svg path {
    fill: #fff;
  }
`;
